import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { getResetByTag, utilityStyles, rem, baseUnits, colors } from '../../../styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("display:inline-block;list-style:none;padding:0 ", rem(baseUnits.rootRhythmUnit / 2), ";vertical-align:text-top;&:first-of-type{padding-left:0;}&:last-child{padding-right:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var spacingStyles = function spacingStyles(_ref) {
  var spacing = _ref.spacing;
  return spacing ? /*#__PURE__*/css("padding:0 ", rem(baseUnits.rootRhythmUnit * (spacing / 2)), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:spacingStyles;")) : '';
};
var dividerStyles = function dividerStyles(_ref2) {
  var divider = _ref2.divider;
  var border = "".concat(rem(1), " solid ").concat(colors.gray_300);
  switch (divider) {
    case 'left':
      return /*#__PURE__*/css("border-left:", border, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:dividerStyles;"));
    case 'right':
      return /*#__PURE__*/css("border-right:", border, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:dividerStyles;"));
  }
};
var resetStyles = getResetByTag('li');
var StyledHorizontalListItem = /*#__PURE__*/_styled('li', process.env.NODE_ENV === "production" ? {
  target: "e8zquq80"
} : {
  target: "e8zquq80",
  label: "StyledHorizontalListItem"
})(resetStyles, defaultStyles, spacingStyles, dividerStyles, utilityStyles);
export default StyledHorizontalListItem;